// import React, { useState } from "react";
// import { FormFieldSet } from "../../../../../components";

// const FileUploadList = () => {
//   const [selectedFiles, setSelectedFiles] = useState([]);

//   const handleFileSelect = (files) => {
//     console.log(files);
//     setSelectedFiles(files);
//   };

//   return (
//     <div
//       className={`flex flex-1 transition-all duration-500 py-4 ${
//         selectedFiles.length > 0
//           ? "justify-start items-start"
//           : "justify-center items-center"
//       }`}
//     >
//       <div>
//         <FormFieldSet
//           noTitle
//           type="fileupload"
//           onFileSelect={handleFileSelect}
//           cardHeight="h-100"
//           cardWidth="w-80"
//         />
//       </div>
//     </div>
//   );
// };

// export default FileUploadList;

import React, { useState } from "react";
import { FormFieldSet } from "../../../../../components";
import { FILE_UPLOAD_PROPS, PropsTable } from "./Props/Props";

const CATEGORIES = {
  core: { label: "Core", color: "#EFF6FF", textColor: "#1D4ED8" },
  display: { label: "Display", color: "#F0FDF4", textColor: "#15803D" },
};
const FileUploadList = () => {
  const [selectedFiles, setSelectedFiles] = useState([]);

  const handleFileSelect = (files) => {
    setSelectedFiles(files);
  };

  return (
    <div>
      <div
        className={`flex flex-1 transition-all duration-500 py-4 ${
          selectedFiles.length > 0
            ? "justify-start items-start"
            : "justify-center items-center"
        }`}
      >
        <div>
          <FormFieldSet
            noTitle
            type="fileupload"
            files={selectedFiles}
            onFileSelect={handleFileSelect}
            cardHeight="h-100"
            cardWidth="w-80"
          />
        </div>
      </div>

      <PropsTable
        data={FILE_UPLOAD_PROPS}
        title="File  Upload — Props Reference"
        typeLabel='type="fileupload"'
        categories={CATEGORIES}
      />

      {/* drag and drop callout */}
      <div className="mt-3 bg-info-50 border border-info-200 rounded-lg p-4 text-xs text-info-900">
        <p className="font-medium mb-1">Drag and drop support</p>
        <p className="leading-relaxed">
          Files can be dropped directly onto the empty drop zone or onto the
          "Add more" card that appears after the first upload. The drop zone
          highlights with a light primary background while a file is being
          dragged over it.
        </p>
      </div>
    </div>
  );
};

export default FileUploadList;
